import { Applications } from '../../../routing/routes';

export const goToApplicationHome = (
    applicationID: string,
    navService: { goToUrl: (url: string) => void },
    event: React.MouseEvent,
): void => {
    if (event.metaKey || event.ctrlKey) {
        if (applicationID === Applications.INSIGHTS) {
            window.open('#/insights/home', '_blank');
        } else if (applicationID === Applications.DATA) {
            window.open('#/data/tables', '_blank');
        } else if (applicationID === Applications.DEVELOP) {
            window.open('#/develop', '_blank');
        }
        return;
    }

    if (applicationID === Applications.INSIGHTS) {
        navService.goToUrl('/insights/home');
    } else if (applicationID === Applications.DATA) {
        navService.goToUrl('/data/tables');
    } else if (applicationID === Applications.DEVELOP) {
        navService.goToUrl('/develop');
    }
};
